import request from '@/utils/request'

export function getCreationSettings() {
  return request.get('/users/admin/creation/settings')
}

export function saveCreationSettings(data) {
  return request.post('/users/admin/creation/settings/save', data)
}
